import Vue from 'vue'

// add translations directly to the application
Vue.i18n.add('login', require('./login.json'))
Vue.i18n.set('login')

// set fallback for non-translated strings
Vue.i18n.fallback('login')
